<template>
  <div>
    <v-row>
      <v-spacer />
      <v-col>
        <v-card>
          <v-tabs
              show-arrows
              v-model="tab"
              class="mb-4"
          >
            <v-tab v-for="tab in tabs" v-bind:key="tab.id">
              <v-icon class="mr-2">{{ tab.icon }}</v-icon>
              {{ tab.title }}
            </v-tab>
          </v-tabs>
        </v-card>
        <v-progress-linear v-if="loading" indeterminate class="py-0 my-0"/>
      </v-col>
      <v-spacer />
    </v-row>

    <div id="scroll-target"></div>
    <v-tabs-items v-model="tab" class="pt-2 px-1">
      <location-post
          v-for="post in posts.data"
          v-bind:key="post.id"
          :id="post.id"
          :title="get(post, 'event_title', '')"
          :summary="get(post, 'summary', '')"
          :type="get(post, 'topic_type', '')"
          :action-button-link="get(post, 'action_url', '')"
          :action-button-type="get(post, 'action_type', '')"
          :created-at="get(post, 'create_time_formatted', '')"
          :alert-type="get(post, 'alert_type', '')"
          :event-schedule="get(post, 'event_schedule_formatted', '')"
          :event-schedule-code="get(post, 'event_schedule_code_formatted', '')"
          :offer-coupon-code="get(post, 'offer_coupon_code', '')"
          :offer-redeem-online-url="get(post, 'offer_redeem_online_url', '')"
          :offer-terms-and-conditions="get(post, 'offer_terms_conditions', '')"
          :location-name="get(post, 'location_name', '')"
          :location-phone="get(post, 'location.primary_phone', '')"
          :on-updated="fetchPosts"
          :open-date="parseDate(get(post, 'event_start_date', ''))"
          :open-time="parseTime(get(post, 'event_start_date', ''))"
          :close-date="parseDate(get(post, 'event_end_date', ''))"
          :close-time="parseTime(get(post, 'event_end_date', ''))"
          :background="getBackground(get(post, 'media[0].sourceUrl', ''))"
          :media="get(post, 'media[0].sourceUrl', '')"
          :media-format="get(post, 'media[0].mediaFormat', '')"
      />
    </v-tabs-items>

    <div class="text-center my-4">
      <v-btn :disabled="page === 1" icon elevation="2" class="mr-1" @click="previousPage">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn :disabled="Array.isArray(posts.data) && posts.data.length < limit" icon elevation="2" class="ml-1"
             @click="nextPage">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>

    <location-post-modal
        :location-name="get(location, 'data.name', '')"
        :location-phone="get(location, 'data.primary_phone', '')"
        :on-updated="fetchPosts"
        fab
    />

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import LocationPost from '@/views/Locations/Components/LocationPost'
import LocationPostModal from '@/views/Locations/Modals/LocationPostModal'
import {handleResponseError} from '@/api/handleError'
import * as postsConstants from '@/constants/posts'
import {mapState} from 'vuex'
import {get} from 'lodash'
import backgroundVideoDefault from '@/assets/video-logodefault.png'

export default {
  name: 'LocationPostsTab',
  components: {
    LocationPost,
    LocationPostModal
  },
  computed: {
    ...mapState({
      posts: state => state.posts.all,
      location: state => state.locations.location
    }),
    get: function() {
      return get
    }
  },
  watch: {
    location(location) {
      if (location) {
        this.location_name = location.name
        this.location_phone = location.primary_phone

        this.fetchPosts()
      }
    },
    tab(newTab) {
      if (newTab === 0) this.type = null
      if (newTab === 1) this.type = postsConstants.ALERT_TYPE
      if (newTab === 2) this.type = postsConstants.OFFER_TYPE
      if (newTab === 3) this.type = postsConstants.STANDARD_TYPE
      if (newTab === 4) this.type = postsConstants.EVENT_TYPE
      this.page = 1
    },
    page() {
      this.fetchPosts()
      this.$vuetify.goTo('#scroll-target')
    }
  },
  data: () => ({
    loading: false,
    location_phone: '',
    location_name: '',
    type: null,
    tab: null,
    tabs: [
      { id: null, title: 'Todas' },
      { id: 2, title: 'Alertas' },
      { id: 3, title: 'Ofertas' },
      { id: 4, title: 'Novidades' },
      { id: 5, title: 'Eventos' },
    ],
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    limit: 15,
    page: 1
  }),
  created() {
    this.fetchPosts()
  },
  methods: {
    showNotification: function(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    fetchPosts: async function() {
      if (!get(this.location, 'data.name')) {
        return
      }

      this.loading = true
      await this.$store.dispatch('posts/getPosts', {
        location_name: get(this.location, 'data.name'),
        limit: this.limit,
        page: this.page,
        topic_type: this.type,
        sort: 'create_time',
        desc: true,
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as publicações.')
        this.showNotification(message, 'red darken-2')
        this.loading = false
      })
      this.loading = false
    },
    parseDate: function (date) {
      if (typeof date !== 'string') return ''
      const d = date.split(' ')
      return d[0]
    },
    parseTime: function (time) {
      if (typeof time !== 'string') return ''
      const d = time.split(' ')
      return d[1]
    },
    getBackground: function(media) {
      let contains = media.includes('mp4')
      if(contains)
        return backgroundVideoDefault

      return media
    },
    getTotalPages: function() {
      const total = parseInt(get(this.posts, 'meta.total', 0))
      const perPage = parseInt(get(this.posts, 'meta.per_page', 0))

      return total && perPage ? Math.floor(total / perPage) : 0
    },
    nextPage() {
      this.page = this.page + 1
    },
    previousPage() {
      this.page = this.page - 1 > 0 ? this.page - 1 : 1
    },
  }
}
</script>

<style scoped>

</style>